import * as api from 'src/api/auth'
import { Cognito } from 'src/external/aws'
import { AuthService as AuthServiceInterface } from './types'

class Service implements AuthServiceInterface {
  signIn = async (
    param: { email: string; password: string },
    callbacks: {
      onSuccess: VoidFunction
      onPasswordResetRequired: VoidFunction
      onNewPasswordRequired: (cb: (password: string) => Promise<any>) => void
    },
  ) => {
    const user = await Cognito.signIn(param.email, param.password)
    if (!user)
      return Promise.reject('メールアドレスまたはパスワードに誤りがあります。')

    const { onSuccess, onPasswordResetRequired, onNewPasswordRequired } =
      callbacks
    if (user.challengeName === 'PASSWORD_RESET_REQUIRED') {
      Cognito.resetPasswordRequest(param.email)
      onPasswordResetRequired()
      return
    }
    if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
      onNewPasswordRequired(async (password: string) => {
        const newUser = await Cognito.newPassword(user, password)
        const session = newUser?.getSignInUserSession()
        if (!session) return
        await api.signInWithCognito(session.getIdToken().getJwtToken())
        onSuccess()
      })
      return
    }
    const session = user.getSignInUserSession()
    if (!session) return
    const response = await api.signInWithCognito(
      session.getIdToken().getJwtToken(),
    )
    const currentCompany = response.data?.currentCompany
    if (!currentCompany) return

    if (
      currentCompany.role === 'sales_demo' &&
      !currentCompany.withInSalesDemoPlanPeriod
    )
      return Promise.reject('このアカウントは現在使用期間外になります。')

    onSuccess()
  }

  signInWithFacebook = Cognito.signInWithFacebook

  signOut = async () => {
    await Cognito.signOut()
    await api.signOut()
  }

  resetPasswordRequest = Cognito.resetPasswordRequest

  resetPassword = async ({
    email,
    verificationCode,
    newPassword,
  }: {
    email: string
    verificationCode: string
    newPassword: string
  }) => Cognito.resetPassword(email, verificationCode, newPassword)

  changePassword = Cognito.changePassword

  initialize = async () => {
    if (typeof window === undefined) return

    return Cognito.intialize()
  }

  idToken = () => Cognito.currentIdToken()
}

export const AuthService = new Service()
